<template>
  <mdb-container>
    <mdb-card class="text-left" v-if="event">
      <mdb-card-header class="color-primary text-white">
        <h4>Questions to Ask During Reservation Process</h4>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-btn @click="doCancel" size="sm" rounded>
          <mdb-icon icon="arrow-left"/>
          Back to Main
        </mdb-btn>
        <mdb-btn @click="addQuestion" icon="plus-circle" rounded size="sm">Add</mdb-btn>
        <mdb-tbl responsive striped>
          <mdb-tbl-head class="primary-color text-white">
            <tr>
              <th>Seq#</th>
              <th>Question</th>
              <th>Type</th>
              <th>&nbsp;</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr class="text-left" v-for="q in event.questions">
              <td>{{q.sequence}}</td>
              <td>{{q.text}}</td>
              <td>{{q.type}}</td>
              <th>
                <mdb-btn @click="editQuestion(q)" icon="pencil" rounded size="sm"/>
                <mdb-btn @click="deleteQuestion(q)" color="danger" icon="trash" rounded size="sm"/>
              </th>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-body>
    </mdb-card>
    <mdb-modal :show="editModal" @close="editModal = false" class="text-left" v-if="questionEditWork">
      <mdb-modal-header :close="true" class="primary-color text-center text-white">
        <h5>Edit Question</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input label="Text" placeholder="Text of the Question" type="text" v-model="questionEditWork.text"/>
        <mdb-input id="cb1" label="Required to Reserve a Spot" type="checkbox"
                   v-model="questionEditWork.required"/>
        <mdb-input id="cb2" label="Answer Visible to Members" type="checkbox"
                   v-model="questionEditWork.visibleToMembers"/>
        <div class="mb-4 mt-4">
          <label>Type of Answer Expected</label>
          <mdb-input id="sa1" label="Short Answer" name="radioGroup" radioValue="Short Answer" type="radio"
                     v-model="questionEditWork.type"/>
          <mdb-input id="sa2" label="Long Answer" name="radioGroup" radioValue="Long Text" type="radio"
                     v-model="questionEditWork.type"/>
          <mdb-input id="sa3" label="Yes or No" name="radioGroup" radioValue="Yes/No" type="radio"
                     v-model="questionEditWork.type"/>
          <mdb-input id="sa4" label="Acknowledgement" name="radioGroup" radioValue="Acknowledgement" type="radio"
                     v-model="questionEditWork.type"/>
        </div>
        <div class="mb-4 mt-4">
          <mdb-input id="nn" label="Sequence#" type="number" v-model="questionEditWork.sequence"/>
        </div>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn @click="doSave" icon="save" v-if="questionEditWork.text">
          Save
        </mdb-btn>
        <mdb-btn @click="cancelEdit">
          <mdb-icon icon="window-close"/>
          Cancel
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal :show="deleteModal" @close="deleteModal = false" class="text-center" danger size="sm">
      <mdb-modal-header :close="false" center>
        <p class="heading">Are you sure you wish to delete this question?</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <p>Deleting this question will also delete any answers already received.</p>
        <mdb-icon class="animated" icon="times" size="4x"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click="doDelete" color="danger">Yes</mdb-btn>
        <mdb-btn @click="deleteModal = false" color="success">No</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>


  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
    name: 'Event-Questions-Editor',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput, mdbCard, mdbCardHeader, mdbCardBody,
      mdbContainer, mdbTbl, mdbTblHead, mdbTblBody,
      mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter
    },
    props: {
      id: {
        type: Number,
        default: null
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },
    data() {
      return {
        event: null,
        showSeriesModal: false,
        seriesChoice: null,
        editModal: false,
        questionEditWork: null,
        currentQuestion: null,
        deleteModal: false
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true);
      api.get("/event/questions/" + this.id).then(
        (results) => {
          this.event = results.data;
        },
        (error) => {
          this.$notify.error({message: "Could not load questions. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      cancelEdit() {
        this.questionEditWork = null
        this.currentQuestion = null
        this.editModal = false
      },
      editQuestion(q) {
        this.questionEditWork = {}
        this.currentQuestion = q
        Object.assign(this.questionEditWork, q)
        this.editModal = true
      },
      deleteQuestion(q) {
        this.currentQuestion = q
        this.deleteModal = true
      },
      addQuestion() {
        this.questionEditWork = {
          id: null,
          type: "Short Answer",
          required: false,
          text: "",
          visibleToMembers: true,
          sequence: this.event.questions.length + 1
        }
        this.editModal = true
      },
      doCancel() {
        this.$emit("cancel")
      },
      setSeriesChoice(choice) {
        this.event.series = choice
        this.doSave()
      },
      doSave() {
        this.editModal = false
        this.$store.dispatch("setExecuting", true);
        api.post('/event/questions/' + this.id, this.questionEditWork).then(
          (results) => {
            if (this.questionEditWork.id) Object.assign(this.currentQuestion, results.data)
            else (this.event.questions.push(results.data))
            this.currentQuestion = null;
            this.questionEditWork = null
            this.event.questions.sort(function (a, b) {
              return a.sequence - b.sequence;
            })
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
            this.editModal = true
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doDelete() {
        this.deleteModal = false
        this.$store.dispatch("setExecuting", true)
        api.delete('/event/questions/' + this.id + "?question=" + this.currentQuestion.id).then(
          (results) => {
            let loc = this.event.questions.indexOf(this.currentQuestion)
            this.event.questions.splice(loc, 1)
            this.currentQuestion = null
            this.event.questions.sort(function (a, b) {
              return a.sequence - b.sequence;
            })
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }
  }
  ;
</script>
